import React from 'react'
import { withNavigation } from '../templates/navigation/withNavigation'
import PromotionList from '../templates/promotion-list/PromotionList';

const PromotionPage = () => <PromotionList/>

export default withNavigation({ title: 'News' })(PromotionPage)



// WEBPACK FOOTER //
// ./src/components/pages/PromotionPage.js